import React, { useState, useContext, useEffect } from "react"
import blogFetch from "../../axios/config";
import Context from "../../context/Context";
import Button from "@mui/material/Button";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import toast from "react-hot-toast";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import language from "../../nls/language.json";
import { ExpandMore } from "@mui/icons-material";
import { AddProductModal, EditProductModal } from "./modals";
import './Combinations.css';

const INITIAL_ADD_PRODUTO = {
  prodGrupo_ProdCod: "",
  prodGrupo_GrupoNome: ""
};

const PRODUTO = "PRODUTO";
const EDIT_PRODUTO = "EDIT_PRODUTO";

export default function ProductsTable() {
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [ShowModalEdit, setShowModalEdit] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState({})
  const [selectedAddProduct, setSelectedAddProduct] = useState(INITIAL_ADD_PRODUTO)

  const [grupoProdutos, setGrupoProdutos] = useState([]);
  const [produtosOptions, setProdutosOptions] = useState([]);

  const {
    selectedCountry,
  } = useContext(Context);

  useEffect(() => {
    getGrupoProduto();
    getProdutosOptions();
  }, [])

  const getGrupoProduto = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_TipoProdutoGrupo/grupoNome/products`);
      setGrupoProdutos(data);
    } catch (error) {
      console.error(error);
    }
  }

  const getProdutosOptions = async () => {
    try {
      const { data } = await blogFetch.get('/SAGA_Caracteristicas/produtos');
      setProdutosOptions(data);
    } catch (error) {
      console.error(error);
    }
  }

  const postProduct = async (data) => {
    try {
      await blogFetch.post('/ISAGA_TipoProdutoGrupo', data);

      setShowModalAdd(false);
      getGrupoProduto();
      toast.success(language[selectedCountry.name].Cadastro.combinacoes.notification.successAdd, {
        duration: 4000,
      });
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Cadastro.combinacoes.notification.errorAdd, {
        duration: 4000,
      });
    }
  }

  const putProducts = async (data) => {
    try {
      await blogFetch.put(`/ISAGA_TipoProdutoGrupo`, data);
      toast.success(language[selectedCountry.name].Cadastro.combinacoes.notification.successUpdate, {
        duration: 4000,
      });
      getGrupoProduto();
      setShowModalEdit(false);
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Cadastro.combinacoes.notification.errorUpdate, {
        duration: 4000,
      });
    }
  }

  const handleSelectedAddProduct = () => {
    setSelectedAddProduct(INITIAL_ADD_PRODUTO);
    setShowModalAdd(true);
  }

  const handleSelectedProduct = (data) => {
    setSelectedProduct(data);
    setShowModalEdit(true);
  }

  const handleAddProducts = ({ name, value }, type) => {
    switch (type) {
      case PRODUTO:
        setSelectedAddProduct({
          ...selectedAddProduct,
          [name]: value.toUpperCase()
        });
        break;
      case EDIT_PRODUTO:
        setSelectedProduct({
          ...selectedProduct,
          [name]: value.toUpperCase()
        });
        break;
    }
  }

  const checkSaveBtn = (data) => !(data.prodGrupo_ProdCod && data.prodGrupo_GrupoNome);

  return (
    <>
      <div>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Cadastro.combinacoes.produtos.title}
            </h3>
          </div>
          <div>
            <Button
              className="btn add_button"
              variant="primary"
              onClick={() => handleSelectedAddProduct()}
            >
              {language[selectedCountry.name].Cadastro.combinacoes.produtos.btnAdicionar}
            </Button>
          </div>
        </div>
        {grupoProdutos.map((item, i) => (
          <Accordion key={`grupoProdutos-${i}`}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="header-flex accordionSummary"
            >
              <p className="forno-text">{item.prodGrupo_GrupoNome}</p>
            </AccordionSummary>
            <AccordionDetails>
              <table className="table table-hover">
                <thead className="table-header">
                  <tr className="table_row">
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.produtos.tableHeader.nome}</th>
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.produtos.tableHeader.grupo}</th>
                    <th>{language[selectedCountry.name].Cadastro.combinacoes.produtos.tableHeader.editar}</th>
                  </tr>
                </thead>
                <tbody className="table_row">
                  {item.products.map((itemProd, indexItemProd) => (
                    <tr key={`grupoProdutos-table-${indexItemProd}`}>
                      <td>{itemProd.prodGrupo_ProdCod}</td>
                      <td>{itemProd.prodGrupo_GrupoNome}</td>
                      <th className="edit">
                        <center>
                          <ModeEditIcon
                            color="info"
                            onClick={() => handleSelectedProduct(itemProd)}
                          />
                        </center>
                      </th>
                    </tr>
                  ))}
                </tbody>
              </table>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
      <AddProductModal
        showModalAdd={showModalAdd}
        setShowModalAdd={setShowModalAdd}
        handleAddProducts={handleAddProducts}
        selectedAddProduct={selectedAddProduct}
        grupoProdutos={grupoProdutos}
        produtosOptions={produtosOptions}
        postProduct={postProduct}
        checkSaveBtn={checkSaveBtn}
      />
      <EditProductModal
        ShowModalEdit={ShowModalEdit}
        setShowModalEdit={setShowModalEdit}
        handleAddProducts={handleAddProducts}
        selectedProduct={selectedProduct}
        grupoProdutos={grupoProdutos}
        produtosOptions={produtosOptions}
        putProducts={putProducts}
        checkSaveBtn={checkSaveBtn}
      />
    </>
  )
}

